export default __webpack_public_path__ + "static/media/single-project-page-05-img-17.c5aa4514.jpg";